import React, { useState } from "react";
import Modal from "../../../../components/Modal";
import SlotSelection from "../../../Booking/components/SlotSelection/SlotSelection";
import { useLoader } from "../../../../context/LoadingContext";
import { modifyAppointment } from "../../../../network/api/users/appointment/appointment";
import { addMinutesToTime } from "../../../Booking/utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { logAppointmentEvent } from "../../../../services/analytics";
import { AppointmentAnalyticsChannel, AppointmentAnalyticsEvent } from "../../../../dto/analyticsDto";
import { Appointment, Slot } from "../../../../dto/interfaces";

interface UpdateAppointmentModalProps {
  id: string;
  doctorId: string;
  start: string;
  duration: number;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAppointment: React.Dispatch<React.SetStateAction<Appointment | null>>;
  serviceId: string;
  token: string;
}

const UpdateAppointmentModal = ({
  id,
  doctorId,
  start,
  open,
  setOpen,
  duration,
  serviceId,
  setAppointment,
  token,
}: UpdateAppointmentModalProps) => {
  const { setLoading } = useLoader();
  const [slots, setSlots] = useState<Slot[]>([]);
  const [date, setDate] = useState<string>(
    new Date(start).toISOString().split("T")[0]
  );
  const [slot, setSlot] = useState<Slot | null>(null);

  const UpdateAppointmentHandler = async () => {
    try {
      setLoading(true);
      const header = {
        Authorization: token,
      };

      const res:any = await modifyAppointment(
        {
          id: id,
          appointmentId: id,
          startTime: slot?.start,
          endTime: slot?.end,
        },
        header
      );
      toast.success("Appointment Updated Successfully");
      logAppointmentEvent({
        appointment: res as Appointment,
        action: AppointmentAnalyticsEvent.RESCHEDULED,
        channel: AppointmentAnalyticsChannel.PATIENT_WEB
      })
      setAppointment(res as Appointment);
    } catch (error:any) {
      toast.error("Error " + error.response.data.message);
      throw (error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        onConfirm={() => {
          UpdateAppointmentHandler();
          setOpen(false);
        }}
        title="Update your Appointment Details"
        cancelText="Cancel"
        confirmText="Save"
      >
        <SlotSelection
          doctorId={doctorId}
          serviceId={serviceId}
          selectedDate={date}
          setSelectedDate={setDate}
          selectedSlot={slot}
          setSelectedSlot={setSlot}
          slots={slots}
          setSlots={setSlots}
        />
      </Modal>
    </div>
  );
};

export default UpdateAppointmentModal;
